/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { FormControl, FormErrorMessage } from '@chakra-ui/react';
import { FormValues } from 'types';
import { get } from 'lodash';
import { useFormikContext } from 'formik';

export const Control: React.FC<any> = ({ name, ...rest }) => {
  const { touched, errors } = useFormikContext<FormValues>();
  const isTouched = get(touched, name);
  const error = get(errors, name);

  return <FormControl {...rest} isInvalid={error && isTouched} />;
};

export const MetaError: React.FC<any> = ({ name, ...rest }) => {
  const { errors } = useFormikContext<FormValues>();
  const error = get(errors, name);

  return <FormErrorMessage {...rest}>{error}</FormErrorMessage>;
};
